import { ApiService } from './api.service';
import { SchoolClassTrendResults } from '@/models/school-class/school-class-trend-results';

class SchoolClassTrendService extends ApiService {
  constructor() {
    super();
  }

  getSchoolClassTrendResults(): Promise<SchoolClassTrendResults> {
    return this.get(SchoolClassTrendResults, 'schoolClasses/trend', {});
  }
}

export const schoolClassTrendService = new SchoolClassTrendService();
